import PropTypes from 'prop-types';
import React from 'react';
import VideoListItem from './video_list_item';

const VideoList = (props) => {
  const videoItems = props.videos.map(video => (
    <VideoListItem
      key={video.etag}
      video={video}
      handleVideoSelection={props.handleVideoSelection}
      isSelected={props.selectedVideo === video}
      handleVideoRemove={props.handleVideoRemove}
    />
  ));

  const selectAVideoLabel = (
    <label className="mb-half">
      {I18n.t('js.listingForm.videos.chooseAVideo')}
    </label>
  );

  return (
    <div className="mt-1">
      {props.videos.length !== 0 && props.selectedVideo == null && selectAVideoLabel}
      <ul className="video-list">
        {videoItems}
      </ul>
    </div>
  );
};

VideoList.propTypes = {
  videos: PropTypes.array.isRequired,
  handleVideoSelection: PropTypes.func.isRequired,
  selectedVideo: PropTypes.object,
  handleVideoRemove: PropTypes.func.isRequired,
};

export default VideoList;
